import { useEffect, useRef, useState } from "react"
import { Send } from "@mui/icons-material"
import { IconButton, TextField } from "@mui/material"
import { useAiTeammateContext, useSendMessageContext } from "../../hooks/context"
import { useShouldDisableUserInput } from "../../hooks/selectors"
import "./style.scss"

function AiTeammateMessageInput() {
  const inputRef = useRef(null)
  const { userMessageInputOverride } = useAiTeammateContext()
  const { sendMessage } = useSendMessageContext()
  const isUserInputDisabled = useShouldDisableUserInput()
  const [message, setMessage] = useState(userMessageInputOverride)

  useEffect(() => {
    setMessage(userMessageInputOverride)
  }, [userMessageInputOverride])

  useEffect(() => {
    if (inputRef.current && !isUserInputDisabled) {
      inputRef.current.focus()
    }
  }, [isUserInputDisabled])

  const canSendMessage = !!message.trim() && !isUserInputDisabled

  function handleChange(e) {
    setMessage(e.target.value)
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      handleSendMessage()
    }
  }

  function handleSendMessage() {
    if (canSendMessage) {
      sendMessage(message)
      setMessage("")
    }
  }

  return <div className="message-input">
    <div className="container" onClick={() => inputRef.current?.focus()}>
      <TextField
        inputRef={inputRef}
        autoFocus
        disabled={isUserInputDisabled}
        variant="standard"
        fullWidth
        multiline
        placeholder="Ask about your data (e.g. 'What are my position sizes?')"
        value={message}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        slotProps={{
          input: {
            sx: {
              padding: 0,
            },
            disableUnderline: true,
            "aria-label": "Message input",
          },
        }}
      />
      <div className="actions">
        CTRL + Enter to send
        <IconButton title="Send" disabled={!canSendMessage} onClick={handleSendMessage}><Send fontSize="small" /></IconButton>
      </div>
    </div>
  </div>
}

export default AiTeammateMessageInput
